import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c85c6b06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-2 px-4 bg-white" }
const _hoisted_2 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_3 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_4 = { class: "min-w-50px" }
const _hoisted_5 = { class: "min-w-50px" }
const _hoisted_6 = { class: "text-gray-500" }
const _hoisted_7 = { class: "padding-left" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Audio not supported ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.t('common.reportAudio')}`,
    id: _ctx.id,
    showDialog: _ctx.showDialog,
    onModalClose: _ctx.close,
    widthClass: 'width-600'
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _toDisplayString(_ctx.t("common.close")), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_3, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.t("common.taskName")), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.t("common.audio")), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result, (p, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.audioId.documentName), 1),
                _createElementVNode("td", _hoisted_7, [
                  (p.fileId)
                    ? (_openBlock(), _createElementBlock("audio", {
                        preload: "audio",
                        controls: "",
                        class: "w-100",
                        key: p.fileId
                      }, [
                        _createElementVNode("source", {
                          src: `${p.fileId}`,
                          type: "audio/mpeg"
                        }, null, 8, _hoisted_8),
                        _hoisted_9
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "id", "showDialog", "onModalClose"]))
}